export interface RoleListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  role_type?: string | null;
}

export const defaultRoleListFilter: RoleListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  role_type: '',
};
